/**
 * Defines broadcast keys.
 */

export const APPOINTMENT_BROADCAST_KEYS = {
    events: {
        NOTIFICATION_RECEIVED_EVENT: '.notification.sent',
        APPOINTMENT_CREATED: '.appointment.created',
        APPOINTMENT_UPDATED: '.appointment.updated',
        APPOINTMENT_CANCELED: '.appointment.canceled',
        APPOINTMENT_RESCHEDULED: '.appointment.rescheduled',
        APPOINTMENT_FINISHED: '.appointment.finished',
        APPOINTMENT_PRIORITY_CHANGED: '.appointment.priority.changed',
        SCAN_RECEIVED: '.scan.received'
    },
    channels: {
        appointments: (userId) => `users.${userId}.appointments`,
        scans: (userId) => `users.${userId}.scans`,
    }
};
